export default {
  help: 'Help',
  form: 'Form',
  pack: 'Pack', // currently unused
  blog: 'Blog',
  // ignore the case type, as 'case' is a js keyword and messes shiz up
  // prettier-ignore
  'case': 'Case', // should be deprecated and rolled into 'Blog',
  askAnvil: 'AskAnvil',
}
